import { SWMS_SHIFT_PRE_START_CHECKLIST_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const getError = (error) => error && error.response && error.response.data && error.response.data.message
  ? error.response.data.message
  : (error ? Strings.network_error : null);

const getShiftDocument = (documentType, { jobId, shiftId, swmsId }, abortController = {}) => () => {
  if (!jobId || !shiftId || !swmsId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.get(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/${documentType}`,
    { ...abortController }
  ).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    }
    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(getError(error)));
};

export const getJobShiftEmergencyPlans = (context, abortController = {}) => (
  getShiftDocument("emergency-plans", context, abortController)
);

export const getJobShiftEmergencyProcedures = (context, abortController = {}) => (
  getShiftDocument("emergency-procedures", context, abortController)
);
